<template>
    <md-dialog :md-active="visible">
        <md-dialog-title>Generar Reporte Mensual</md-dialog-title>
        <md-dialog-content>
            <md-field>
                <label></label>
                <select v-model="regionalSeleccionada" class="md-input" required>
                    <option disabled value="">Seleccione una regional</option>
                    <option v-for="reg in regionales" :key="reg.id" :value="reg.id">
                        {{ reg.nombre }}
                    </option>
                </select>
            </md-field>
              <label>Desde</label>
            <md-field>
              
                <md-input type="date" v-model="fechaInicio" />
            </md-field>
             <label>Hasta</label>
            <md-field>
               
                <md-input type="date" v-model="fechaFin" />
            </md-field>
        </md-dialog-content>
        <md-dialog-actions>
            <md-button class="md-primary" @click="emitirReporte">Generar Reporte</md-button>
            <md-button @click="cerrar">Cancelar</md-button>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
export default {
    props: {
        visible: Boolean
    },
    data() {
        return {
            regionales: [],
            regionalSeleccionada: '',
            fechaInicio: '',
            fechaFin: ''
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.regionalSeleccionada = '';
                this.cargarRegionales();
            }
        }
    },
    methods: {
        async cargarRegionales() {
            const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/regional/listar_regionales.php');
            this.regionales = await res.json();
        },
        async emitirReporte() {
            this.$emit('generar', {
                regional_id: this.regionalSeleccionada,
                desde: this.fechaInicio,
                hasta: this.fechaFin
            });
            this.cerrar();
        },
        cerrar() {
            this.$emit('close');
        },
        convertImageToBase64(url) {
            return fetch(url)
                .then(response => response.blob())
                .then(
                    blob =>
                        new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onloadend = () => resolve(reader.result);
                            reader.onerror = reject;
                            reader.readAsDataURL(blob);
                        })
                );
        },
        async generarReportePDF({ regional_id, desde, hasta }) {
            const doc = new jsPDF();
            let yPos = 10;
            const logoUrl = '/fondotam.png';

            try {
                const logoBase64 = await this.convertImageToBase64(logoUrl);
                doc.addImage(logoBase64, "PNG", 12, 5, 25, 16);
            } catch (error) { }


            doc.setFontSize(12);
            doc.text("Reporte Mensual de Servicios", 60, yPos + 6);
            doc.setFontSize(10);
            doc.text(`Regional: ${this.regionales.find(r => r.id == regional_id)?.nombre || ''}`, 15, yPos + 14);
            doc.text(`Desde: ${desde}   Hasta: ${hasta}`, 15, yPos + 20);
            yPos += 28;

            let vuelos = [];
            try {
                const params = new URLSearchParams({ regional_id, desde, hasta });
                const res = await fetch(`https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/list/reporte_mensual_datos.php?${params}`);
                vuelos = await res.json();
            } catch (e) {
                doc.text("No se pudo obtener la información.", 10, yPos);
                doc.save("reporte_mensual.pdf");
                return;
            }

            let globalTotal = 0;
            vuelos.forEach((vuelo, idx) => {
                doc.setFontSize(9);
                doc.setFont("helvetica", "bold");
                doc.text(
                    `N° Constancia: ${vuelo.numero_constancia}   N° Vuelo: ${vuelo.numero_vuelo}   Fecha: ${vuelo.fecha}   Regional: ${vuelo.regional}`,
                    15, yPos
                );
                yPos += 5;
                doc.setFont("helvetica", "normal");

                const serviciosPorCategoria = {};
                vuelo.servicios.forEach(s => {
                    if (!serviciosPorCategoria[s.categoria]) serviciosPorCategoria[s.categoria] = [];
                    serviciosPorCategoria[s.categoria].push(s);
                });

                Object.keys(serviciosPorCategoria).forEach(category => {
                    const rows = serviciosPorCategoria[category].map(serv => [
                        serv.servicio,
                        serv.valor_unitario,
                        serv.constancias,
                        serv.total,
                        serv.observaciones
                    ]);
                    const header = [category, "Importe Contrato", "Constancias", "Importe $", "Observaciones"];
                    autoTable(doc, {
                        head: [header],
                        body: rows,
                        startY: yPos,
                        theme: "grid",
                        styles: { fontSize: 8, cellPadding: 1 },
                        headStyles: { fillColor: [0, 123, 255], textColor: [255, 255, 255] }
                    });
                    yPos = doc.lastAutoTable.finalY + 1;
                });

       
                let vueloTotal = vuelo.servicios.reduce((acc, s) => acc + Number(s.total), 0);
                globalTotal += vueloTotal;
                doc.text(`Total vuelo: $${vueloTotal.toFixed(2)}`, 160, yPos);
                yPos += 8;


                if (yPos > 250 && idx < vuelos.length - 1) {
                    doc.addPage();
                    yPos = 10;
                }
            });

            // 3. Total global
            doc.setFontSize(12);
            doc.text(`TOTAL GENERAL: $${globalTotal.toFixed(2)}`, 140, yPos + 10);
          
            doc.save("reporte_mensual.pdf");
        },
    }
};
</script>